import React, { Component } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faArrow from '@fortawesome/fontawesome-free-solid/faLongArrowAltRight';
import Config from '../config/config';
import './NewsBox.css';
// import stihlImg from '../images/icon/ICON_PRODUCT.png';

class NewsBox extends Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.props.history.push({
      pathname: `/news/detail/${this.props.data.id}`,
      state: { filter: this.props.match.params.filter },
    });
  }

  render() {
    const {
      date, title, content, image, newstype
    } = this.props.data;
    let truncatedContent = content || "";
    if (this.props.isShortNews && truncatedContent.length > 200) {
      truncatedContent = `${truncatedContent.slice(0, 197)}...`;
    }
    const dateObj = date ? new Date(date) : false;
    const dateStr = dateObj ? `${dateObj.getFullYear()}-${dateObj.getMonth()+1}-${dateObj.getDate()}` : "";

    let imageUrl = image ? image.url : null;
    if(imageUrl){
      imageUrl = `${Config.apiUrl}${imageUrl}`;
    }else{
      // imageUrl = stihlImg;
    }

    return (
      <div
        className="box news-box"
      >
        <article className="media">
          <div className="media-left">
            <figure className={`image is-48x48 type-${newstype.name}`}>
              {imageUrl && <img className="image" src={imageUrl} alt={title} />}
            </figure>
          </div>
          <div className="media-content">
            <div className="content">
              <div className="content-header">
                <div className="content-header-date has-text-grey-light">{dateStr}</div>
                <div className="content-header-type">{newstype.title}</div>
              </div>
              <div className="content-header-title">{title}</div>
            </div>
          </div>
        </article>
        <div
          className="content-body"
          dangerouslySetInnerHTML={{ __html: marked(truncatedContent) }}
        />
        <div className="news-box-footer">
          <div 
            className="App-skew-more-button"
            role="button"
            onClick={this.openModal}
            onKeyUp={this.openModal}
          >
            <div>更多資訊</div>
            <FontAwesomeIcon className="news-box-footer-arrow" icon={faArrow}/>
          </div>
        </div>
      </div>
    );
  }
}

NewsBox.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  isShortNews: PropTypes.bool,
};

NewsBox.defaultProps = {
  data: {
    date: new Date().toISOString(),
    type: 'news',
    title: 'Dummy title',
    content: 'Dummy content'
  },
  isShortNews: true,
};

export default NewsBox;



// WEBPACK FOOTER //
// ./src/components/NewsBox.js